import {FORM_ERROR} from 'final-form';
import {enUS, es} from 'date-fns/locale';
import {LANGUAGES} from './translationService';

export const ROOT = document.getElementById('root');

export const SFTP_BASE_ROUTE = '/sftp';
export const ERROR_BASE_ROUTE = '/error';
export const ROUTES = {
    root: '/',
    eap: '/eap',
    sftpPasswordGeneration: `${SFTP_BASE_ROUTE}/password_generation`,
    membership: '/membership',
    activated: '/activated',
    pageNotFound: `${ERROR_BASE_ROUTE}/page_not_found`,
    serverError: `${ERROR_BASE_ROUTE}/server_error`,
    manyRequests: `${ERROR_BASE_ROUTE}/many_requests`
};

export const IS_IE_BROWSER = ['MSIE ', 'Trident/'].some(detectionItem => window.navigator.userAgent.includes(detectionItem));

export const {HJ_ENV: ENV, API_HOST, SEGMENT_KEY, SENTRY_DSN} = (window as any).__RUNTIME_CONFIG__ || {};

const MULTI_ENV_DEV_PREFIX = window.location.hostname.match(/hj[0-9]{2}-dev/)?.[0] || 'hj01-dev';
export const API_DOMAIN = `https://${API_HOST || `member-bff.${MULTI_ENV_DEV_PREFIX}.hjoy.net`}`;

export const HJ_CDN_DOMAIN = {
    'hj01-dev': 'https://cdn.hj01-dev.hjoy.net',
    'hj01-stage': 'https://cdn.hj01-stage.hjoy.net',
    'hj01-prod': 'https://cdn.healthjoy.com'
}[ENV] || `https://cdn.${MULTI_ENV_DEV_PREFIX ? `${MULTI_ENV_DEV_PREFIX}` : 'hj01-dev'}.hjoy.net`;

export const HTTP_CODE_UNAUTHORIZED = 401;
export const HTTP_CODE_NOT_FOUND = 404;
export const HTTP_CODE_GONE = 410;
export const HTTP_CODE_UNPROCESSABLE = 422;
export const HTTP_CODE_TOO_MANY_REQUESTS = 429;
export const SERVER_ERROR = 'SERVER_ERROR';
export const CANCEL_ERROR = 'CANCEL_ERROR';

export const OAUTH_CLIENT_ID = 'test_client';
export const OAUTH_CLIENT_SECRET = 'secret_key';

export const USER_STATUSES = {
    active: 'active',
    notActive: 'not_active',
    deactivated: 'deactivated',
    temporaryLocked: 'temporary_locked',
    futureInvite: 'future_invite'
};

export const EAP_WEBSITE = 'https://mysupportportal.com/gun-login';
export const EAP_TITLE = 'Healthjoy EAP';

export const MIN_LENGTH_REGEXP = /^.{8,}$/g;
export const MAX_LENGTH_REGEXP = /^.{1,256}$/g;
export const UPPERCASE_REGEXP = /[A-Z]/g;
export const LOWERCASE_REGEXP = /[a-z]/g;
export const NUM_REGEXP = /[0-9]/g;
export const INT_REGEXP = /^[0-9]*$/;
export const ALPHABETIC_CHARACTER_REGEXP = /[A-z]/g;
export const ALPHANUMERIC_REGEXP = /^[a-z0-9]+$/i;
export const SPEC_CHARACTER_REGEXP = /[-\\[\]/{}()*+?!@#%&.^$_,'"‘±=~<>|]/g;
export const LETTERS_ROW_REGEXP = /^[A-z]*$/g;
export const NUMBERS_ROW_REGEXP = /^[0-9]*$/g;
export const PHONE_NUMBER_REGEXP = /\([0-9]{3}\)\s[0-9]{3}[-\s.][0-9]{4}$/;
export const EMAIL_REGEXP = /^[a-zA-Z0-9_!.#$%&'*+\-/=?^`{|}~]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/;
export const SECURE_LINK_REGEXP = /^https:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#()?&/=]*)$/;
export const SFTP_PATH_REGEXP = /^[\w\d]+:[\w\d]+@[\w\d.]+$/;

export const FORM_GLOBAL_ERROR = FORM_ERROR;

export const CSS_TEAM_EMAIL = 'success@healthjoy.com';

export const PASSWORD_RULES = {
    minLength: MIN_LENGTH_REGEXP,
    uppercaseLetter: UPPERCASE_REGEXP,
    number: NUM_REGEXP
};

export const LOCALES_BY_LANGUAGE = {
    [LANGUAGES.en]: enUS,
    [LANGUAGES.es]: es
};

export const LOCAL_STORAGE_ITEMS = {
    deviceId: 'deviceId'
};

export const APP_STORE_LINK = 'https://itunes.apple.com/us/app/healthjoy/id1104881108';
export const GOOGLE_PLAY_LINK = 'https://play.google.com/store/apps/details?id=com.healthjoy.groups';
